import * as React from 'react';

/* eslint-disable spellcheck/spell-checker */
function InfoCircle() {
    return (React.createElement("svg", { height: "20", viewBox: "0 0 20 20", width: "20", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M10 0C4.478 0 0 4.48 0 10c0 5.524 4.478 10 10 10s10-4.476 10-10c0-5.52-4.478-10-10-10zm0 4.435a1.694 1.694 0 110 3.388 1.694 1.694 0 010-3.388zm2.258 10.242a.484.484 0 01-.484.484H8.226a.484.484 0 01-.484-.484v-.967c0-.268.217-.484.484-.484h.484v-2.58h-.484a.484.484 0 01-.484-.485v-.967c0-.268.217-.484.484-.484h2.58c.268 0 .484.216.484.484v4.032h.484c.267 0 .484.216.484.484v.967z", fill: "#0A5BBA", fillRule: "evenodd" })));
}
/* eslint-enable spellcheck/spell-checker */

export { InfoCircle as default };
//# sourceMappingURL=InfoCircle.esm.js.map
